import {localizePath, t} from "../../../i18n";
import {Link} from "react-router";
import ProgressiveImage from '../../../commonComponent/image/ProgressiveImage';
import SectionPanel, {SectionCopy} from '../../../commonComponent/section/SectionPanel';
import {imageAssets} from '../../../assets/imageAssets';

const Tapas = () => { return (
    <section data-reveal className="content-row tapas-row">
        <div className="media-panel media-panel--square card-discovery">
            <ProgressiveImage asset={imageAssets.aboutUs2} sizes="(max-width: 639px) 100vw, 50vw"
                              alt={t("altTapas")} className="panel-image"/>
            <Link to={localizePath("/carte")} className="ui-button ui-button--on-image"> {t("home.discover")} <span aria-hidden="true">→</span>
            </Link>
        </div>

        <SectionPanel title={t("tapasTitle")}>
            <SectionCopy paragraphs={[t("tapasTextFirstPar"), t("tapasSecondPar")]}/>
        </SectionPanel>
    </section>
); };

export default Tapas;
